export const getQueries = state => state.queries;
export const getEntities = state => state.entities;
